/* tslint:disable */
/* eslint-disable */
/**
 * Boatsetter API
 * Endpoints require an access token set via the `X-UserToken` header
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DomesticV2BookingsBookingIdGuestsGet200Response } from '../models';
/**
 * GuestBookingsApi - axios parameter creator
 * @export
 */
export const GuestBookingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List guests accepted to a booking
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BookingsBookingIdGuestsGet: async (bookingId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('domesticV2BookingsBookingIdGuestsGet', 'bookingId', bookingId)
            const localVarPath = `/domestic/v2/bookings/{booking_id}/guests`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes a guest
         * @param {string} bookingId 
         * @param {string} guestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BookingsBookingIdGuestsGuestPublicIdDelete: async (bookingId: string, guestPublicId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('domesticV2BookingsBookingIdGuestsGuestPublicIdDelete', 'bookingId', bookingId)
            // verify required parameter 'guestPublicId' is not null or undefined
            assertParamExists('domesticV2BookingsBookingIdGuestsGuestPublicIdDelete', 'guestPublicId', guestPublicId)
            const localVarPath = `/domestic/v2/bookings/{booking_id}/guests/{guest_public_id}`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"guest_public_id"}}`, encodeURIComponent(String(guestPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GuestBookingsApi - functional programming interface
 * @export
 */
export const GuestBookingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GuestBookingsApiAxiosParamCreator(configuration)
    return {
        /**
         * List guests accepted to a booking
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2BookingsBookingIdGuestsGet(bookingId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DomesticV2BookingsBookingIdGuestsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2BookingsBookingIdGuestsGet(bookingId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Removes a guest
         * @param {string} bookingId 
         * @param {string} guestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2BookingsBookingIdGuestsGuestPublicIdDelete(bookingId: string, guestPublicId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2BookingsBookingIdGuestsGuestPublicIdDelete(bookingId, guestPublicId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GuestBookingsApi - factory interface
 * @export
 */
export const GuestBookingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GuestBookingsApiFp(configuration)
    return {
        /**
         * List guests accepted to a booking
         * @param {string} bookingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BookingsBookingIdGuestsGet(bookingId: string, options?: any): AxiosPromise<DomesticV2BookingsBookingIdGuestsGet200Response> {
            return localVarFp.domesticV2BookingsBookingIdGuestsGet(bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes a guest
         * @param {string} bookingId 
         * @param {string} guestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BookingsBookingIdGuestsGuestPublicIdDelete(bookingId: string, guestPublicId: string, options?: any): AxiosPromise<void> {
            return localVarFp.domesticV2BookingsBookingIdGuestsGuestPublicIdDelete(bookingId, guestPublicId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GuestBookingsApi - interface
 * @export
 * @interface GuestBookingsApi
 */
export interface GuestBookingsApiInterface {
    /**
     * List guests accepted to a booking
     * @param {string} bookingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuestBookingsApiInterface
     */
    domesticV2BookingsBookingIdGuestsGet(bookingId: string, options?: AxiosRequestConfig): AxiosPromise<DomesticV2BookingsBookingIdGuestsGet200Response>;

    /**
     * Removes a guest
     * @param {string} bookingId 
     * @param {string} guestPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuestBookingsApiInterface
     */
    domesticV2BookingsBookingIdGuestsGuestPublicIdDelete(bookingId: string, guestPublicId: string, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * GuestBookingsApi - object-oriented interface
 * @export
 * @class GuestBookingsApi
 * @extends {BaseAPI}
 */
export class GuestBookingsApi extends BaseAPI implements GuestBookingsApiInterface {
    /**
     * List guests accepted to a booking
     * @param {string} bookingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuestBookingsApi
     */
    public domesticV2BookingsBookingIdGuestsGet(bookingId: string, options?: AxiosRequestConfig) {
        return GuestBookingsApiFp(this.configuration).domesticV2BookingsBookingIdGuestsGet(bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes a guest
     * @param {string} bookingId 
     * @param {string} guestPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GuestBookingsApi
     */
    public domesticV2BookingsBookingIdGuestsGuestPublicIdDelete(bookingId: string, guestPublicId: string, options?: AxiosRequestConfig) {
        return GuestBookingsApiFp(this.configuration).domesticV2BookingsBookingIdGuestsGuestPublicIdDelete(bookingId, guestPublicId, options).then((request) => request(this.axios, this.basePath));
    }
}
